/**
 * Inline three-dot pulsing loader — no library, CSS-only.
 * Usage: <LoadingDots label="Signing out" />
 */
export default function LoadingDots({ label = "", className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      {label && <span>{label}</span>}
      <span className="inline-flex items-center gap-0.5" aria-hidden="true">
        <span className="loading-dot" />
        <span className="loading-dot" style={{ animationDelay: "160ms" }} />
        <span className="loading-dot" style={{ animationDelay: "320ms" }} />
      </span>
    </span>
  );
}
